import { Container, Tabs, Tab, Row, Col } from "react-bootstrap";
import EventChat from "./EventChat";
import EventScorecards from "./EventScorecards";
import DisplayLeaderboard from "./DisplayLeaderboard";
import EventSection from "./EventSection";
import EventSideGamePlayers from "./EventSideGamePlayers";
import SectionHeader from "./SectionHeader";
import { useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  useEventSideGames,
  useEntriesByEventPlayerScorecardCompleted,
} from "../util/db";
import EventScorecardsMy from "./EventScorecardsMy";

function EventPageTabs({
  isIncompleteCards,
  isCheckedInAlready,
  canCheckIn,
  eventId,
  uid,
  isLoggedIn,
  isEventComplete,
  auth,
  gameId,
  posts,
  eventName,
  eventCourse,
  eventDate,
  eventGameName,
  eventCourseId,
  scoringOrderGolf,
  throwScoringModeId,
  tdName,
  tdId,
}) {
  const chatTitle = useMemo(
    () => (posts?.length > 0 ? `Chat (${posts.length})` : "Chat"),
    [posts]
  );
  const [activeKey, setActiveKey] = useState("scorecards");

  // Get side games data
  const { data: sideGames, status: sideGamesStatus } =
    useEventSideGames(eventId);

  // Get completed scorecards for current user to determine if "My Scores" tab should show
  // Only fetch if user is logged in and has a uid
  const { data: completedScorecards, status: completedScorecardsStatus } =
    useEntriesByEventPlayerScorecardCompleted(
      eventId,
      isLoggedIn && uid ? uid : null,
      {
        enabled: isLoggedIn && !!uid, // Only run query when user is logged in and has a uid
      }
    );

  // Check if there are side games to show the tab
  const hasSideGames =
    sideGamesStatus !== "loading" && sideGames && sideGames.length > 0;

  // Check if there are completed scorecards to show "My Scores" tab
  const hasCompletedScorecards =
    isLoggedIn &&
    uid && // Ensure user ID exists
    completedScorecardsStatus !== "loading" &&
    completedScorecards &&
    completedScorecards.length > 0 &&
    // Additional check: ensure we have actual scorecards with valid data
    completedScorecards.some(
      (entry) =>
        entry.group_scorecard_players &&
        entry.group_scorecard_players.length > 0 &&
        entry.group_scorecard_players[0].group_scorecard &&
        entry.group_scorecard_players[0].group_scorecard.is_complete === true
    );

  useEffect(() => {
    if (isEventComplete) {
      setActiveKey("players");
    }
  }, [isEventComplete]);

  // If "My Scores" tab is active but no longer has data, switch to Score tab
  useEffect(() => {
    if (activeKey === "myscorecards" && !hasCompletedScorecards) {
      setActiveKey("scorecards");
    }
  }, [activeKey, hasCompletedScorecards]);

  return (
    <>
      <Container className="event-tabs-container">
        <Tabs
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k)}
          className="event-tabs mb-4 mt-3"
          fill
          variant="pills"
        >
          <Tab eventKey="scorecards" title="Score">
            <EventScorecards
              isIncompleteCards={isIncompleteCards}
              isCheckedInAlready={isCheckedInAlready}
              canCheckIn={canCheckIn}
              eventId={eventId}
              uid={uid}
              isLoggedIn={isLoggedIn}
              isEventComplete={isEventComplete}
              auth={auth}
              gameId={gameId}
              throwScoringModeId={throwScoringModeId}
            />
          </Tab>
          {hasCompletedScorecards && (
            <Tab eventKey="myscorecards" title="My Scores">
              <EventScorecardsMy
                isIncompleteCards={isIncompleteCards}
                isCheckedInAlready={isCheckedInAlready}
                canCheckIn={canCheckIn}
                eventId={eventId}
                uid={uid}
                isLoggedIn={isLoggedIn}
                isEventComplete={isEventComplete}
                auth={auth}
                gameId={gameId}
                throwScoringModeId={throwScoringModeId}
              />
            </Tab>
          )}
          <Tab eventKey="chat" title={chatTitle}>
            <EventChat eventId={eventId} uid={uid} posts={posts} />
          </Tab>
          <Tab eventKey="scoreboard" title="Scorecards">
            <DisplayLeaderboard
              bg="white"
              textColor="dark"
              size="md"
              bgImage=""
              bgImageOpacity={1}
              title={eventName}
              subtitle=""
              eventId={eventId}
              scoringOrderGolf={scoringOrderGolf}
              isEventComplete={isEventComplete}
              throwScoringModeId={throwScoringModeId}
            />
          </Tab>
          <Tab eventKey="players" title="Leaderboard">
            {scoringOrderGolf !== null ? (
              <EventSection
                bg="white"
                textColor="dark"
                size="md"
                bgImage=""
                bgImageOpacity={1}
                title={eventName}
                subtitle=""
                eventId={eventId}
                scoringOrderGolf={scoringOrderGolf}
                isEventComplete={isEventComplete}
                throwScoringModeId={throwScoringModeId}
              />
            ) : (
              <div>Loading...</div>
            )}
          </Tab>
          {/* <Tab eventKey="players_" title="Leaderboard_">
            {scoringOrderGolf !== null ? (
              <EventSectionLeaderboard
                bg="white"
                textColor="dark"
                size="md"
                bgImage=""
                bgImageOpacity={1}
                title={eventName}
                subtitle=""
                eventId={eventId}
                scoringOrderGolf={scoringOrderGolf}
                isEventComplete={isEventComplete}
                throwScoringModeId={throwScoringModeId}
              />
            ) : (
              <div>Loading...</div>
            )}
          </Tab> */}
          {hasSideGames && (
            <Tab eventKey="sidegames" title="Side Games">
              <Container className="mt-3">
                {sideGames.map((item, index) => (
                  <div key={index}>
                    <SectionHeader
                      title={item.side_game_name}
                      subtitle=""
                      size={1}
                      spaced={false}
                      className="text-center"
                    />
                    <Row>
                      <Col>
                        <EventSideGamePlayers sideGameId={item.id} />
                      </Col>
                    </Row>
                    {index < sideGames.length - 1 && <hr className="my-4" />}
                  </div>
                ))}
              </Container>
            </Tab>
          )}
        </Tabs>
      </Container>
    </>
  );
}

export default EventPageTabs;
